import React from 'react'
import { Box, IconButton, TableCell, TableRow, Typography, useMediaQuery } from '@mui/material'
import EyeIcon from "../../common/assests/eyegreen.png";
import UserImg from "../../common/assests/sampleuser.svg";
import configuration from '../../config/Config';
const UserAllOrderRow = ({order,handleViewMore}) => {
    const isSmallScreen = useMediaQuery("(max-width:480px)");
  return (
    <TableRow
    key={order?.user}
    sx={{
      "&:last-child td, &:last-child th": { border: 0 },
    }}
  >
    <TableCell>
      <Box sx={{ display: "flex", alignItems: "center" }}>
      <img
            src={order?.seller?.picture 
              ? `${configuration.cdnFront}/${order?.seller?.picture}` 
              : UserImg}  
          alt={"img"}
          style={{
            height: "35px",
            width: "35px",
            marginRight: "8px",
            borderRadius: "50%",
          }}
        />
        <Typography sx={{whiteSpace:'nowrap'}}>
          {order?.seller?.fullname || "-"}
        </Typography>
      </Box>
    </TableCell>
    <TableCell  sx={{whiteSpace:'nowrap'}}>
      {order?.address
        ? [
            order.address.address || "",
            // order.address.city || "",
            // order.address.state || "",
            // order.address.country || "",
            // order.address.zipcode || ""
          ]
            .filter(Boolean)
            .join(", ")
        : "-"}
    </TableCell>

    <TableCell>
      {" "}
      {`$${order?.totalAmount || "-"}`}
    </TableCell>

    <TableCell>
      {order?.items?.reduce(
        (total, item) => total + (item?.quantity || 0),
        0
      )}
    </TableCell>

    <TableCell>{order?.paymentStatus || "-"}</TableCell>
    <TableCell>{order?.status || "-"}</TableCell>
    <TableCell>
      <IconButton
       onClick={handleViewMore}>
        <img
          src={EyeIcon}
          alt="viewicon"
          style={{
            height: isSmallScreen ? "35px" : "45px",
            width: isSmallScreen ? "35px" : "45px",
          }}
        />
      </IconButton>
    </TableCell>
  </TableRow>
  )
}

export default UserAllOrderRow